export const enum StateType {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Loading = 'spinner',
  Default = 'default',
}
